module.exports = __webpack_public_path__ + "5be9e032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/partnerships_pricerite.png
// module id = 1706
// module chunks = 0